import React, { useContext } from 'react';
import { ChartContext } from '../ChartProvider';
import { ChartLabels, TabValues } from 'components/DeviceDetails/constants';
import { DeviceTypes } from 'components/DeviceDetails/constants';
import ChartTypeSubmenu from './ChartTypeSubmenu';
import { Switch } from 'components/shadcn/ui/switch';
import { DocumentTextIcon, Bars3Icon } from '@heroicons/react/20/solid';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from 'components/shadcn/ui/dropdown-menu';
import ShowLinesSubmenu from './ShowLinesSubmenu';
import { buttonVariants } from 'components/shadcn/ui/button';

const ChartOptionsMenu = () => {
    const {
        chartType,
        setChartType,
        filteredLines,
        showLines,
        setShowLines,
        viewMode,
        useRawData,
        setUseRawData,
        deviceType,
        generateReport,
        isSiteDetailPage,
    } = useContext(ChartContext);

    if (deviceType === DeviceTypes.NEP) {
        return (
            <h5 className="line-height-2 w-full font-medium">
                {ChartLabels[chartType?.title] || chartType?.title}
            </h5>
        );
    }
    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                className={buttonVariants({
                    variant: 'outline',
                    size: 'icon',
                })}
            >
                <Bars3Icon className="h-4 w-4" />
            </DropdownMenuTrigger>

            <DropdownMenuContent
                className="text-slate-600"
                align="end"
                sideOffset={5}
            >
                <DropdownMenuGroup>
                    {/* Chart Type Submenu */}
                    <ChartTypeSubmenu
                        chartType={chartType}
                        setChartType={setChartType}
                    />

                    {/* Show/Hide Lines Submenu */}
                    <ShowLinesSubmenu
                        lines={filteredLines}
                        showLines={showLines}
                        setShowLines={setShowLines}
                        disabled={chartType.title !== TabValues.All}
                    />

                    <DropdownMenuSeparator />

                    {/* Raw Data Only For Day View Options  */}
                    <DropdownMenuItem
                        className="focus:bg-slate-100"
                        disabled={viewMode !== 'day'}
                        onClick={() => setUseRawData(!useRawData)}
                        onSelect={(e) => e.preventDefault()}
                    >
                        <Switch
                            id="raw-data"
                            className="data-[state=checked]:bg-accent data-[state=unchecked]:bg-slate-300"
                            checked={useRawData}
                            onCheckedChange={() => setUseRawData(!useRawData)}
                        />
                        <span>Raw Data</span>
                    </DropdownMenuItem>

                    {!isSiteDetailPage && (
                        <DropdownMenuItem
                            className="focus:bg-slate-100"
                            onClick={generateReport}
                        >
                            <DocumentTextIcon className="mr-2" />
                            <span>Generate Report</span>
                        </DropdownMenuItem>
                    )}
                </DropdownMenuGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default ChartOptionsMenu;
